import React from 'react';
import PropTypes from 'prop-types';

const Badge = ({ number, top = '6px', right = '8px', type = 'danger' }) => {
    if (!number) return null;

    return (
        <span className={`badge badge-${type} position-absolute`} style={{ zIndex: '99', right, top, borderRadius: '0.5rem' }}>
            {number}
        </span>
    );
};

Badge.propTypes = {
    number: PropTypes.number.isRequired,
    top: PropTypes.string,
    right: PropTypes.string,
    type: PropTypes.string,
};

export default Badge;
